import React, {
  useCallback, useEffect, useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import { AccordionDetails } from '@material-ui/core';
import { useSelector } from 'react-redux';
import {
  CardFooter,
  ContainerPrincipal,
  ContainerResumo,
} from './NotasFiscaisDevedorStyles';
import LoadingUI from '../../components/UI/Loading/LoadingUI';
import Grid24 from '../../components/UI/Grid24';
import { useNotaFiscalDevedorDispatch, useNotaFiscalDevedorSelector } from '../../store/NotasFiscaisDevedor/NotaFiscalDevedorProvider';
import { onChangeFormFieldsAction, setSimpleNotasFiscaisDevedorAction, setSimpleValuesListIdsAction } from '../../store/NotasFiscaisDevedor/NotaFiscalDevedor.store';
import { getMoneyMask, getNewPage } from '../../helpers';
import TabelaNotasFiscaisDevedor from './Tabelas/TabelaNotasFiscaisDevedor';
import { notasFiscaisDevedorFactory } from './NotasFiscaisDevedorFactory';
import PeriodField from '../../components/UI/Field/Period/PeriodField';
import MoneyField from '../../components/UI/Field/Money/MoneyField';
import MaskField from '../../components/UI/Field/Mask/MaskField';
import AlphanumericMaskField from '../../components/UI/Field/Mask/AlphanumericMaskField';
import { CPF_MASK } from '../../helpers/constants/layout.constants';
import { ButtonUI, InputField } from '../../components';
import useStyle from '../NotasFiscais/NotasFiscaisPageStyles';
import { ButtonPesquisar } from '../ContaCorrenteCliente/V2/ContaCorrenteCliente/contaCorrenteClienteStyles';
import WrapperSubTitleForm from '../../components/UI/WrapperSubTitleForm';
import {
  buscarDadosTabelaAction, exportarNotaFiscalDevedorAction, gerarNotaFiscalDevedorAction,
} from '../../store/NotasFiscaisDevedor/NotaFiscalDevedor.saga';
import DialogNew from '../../layouts/FormDialog/DialogNew';
import DialogEditarNotaFiscalDevedor from './Dialogs/DialogEditarNotaFiscalDevedor';
import { Accordion } from '../../components/UI/Inspecionar/Accordion/Accordion';
import DadosGeracaoNF from '../ContaCorrenteCliente/V2/ContaCorrenteCliente/Recebimentos/Accordions/DadosGeraçãoNotaFiscal/DadosGeracaoNF';
import { useCCClienteDispatch } from '../../store/ContaCorrenteCliente/ContaCorrenteClienteProvider';
import { pesquisarDadosGeracaoNotaFiscalAction } from '../../store/ContaCorrenteCliente/contaCorrenteCliente.saga';

function NotasFiscaisDevedorComponent() {
  const dispatch = useNotaFiscalDevedorDispatch();
  const dispatchCCCliente = useCCClienteDispatch();

  const styles = useStyle();

  const permissoesUsuario = useSelector(states => (states.authentication.userInformation ? states.authentication.userInformation.permissoes : []));
  const [permissoes] = useState({
    consultar: permissoesUsuario?.includes('ROLE_1801'),
    consultarTodos: permissoesUsuario?.includes('ROLE_1802'),
    efetuarLancamentos: permissoesUsuario?.includes('ROLE_1803'),
    prestarContas: permissoesUsuario?.includes('ROLE_1804'),
    baixarVisualizarSispagPlanilha: permissoesUsuario?.includes('ROLE_1901'),
  });

  const [conteudoTabela, setConteudoTabela] = useState([]);
  const [isCnpj, setIsCnpj] = useState(false);
  const [onOpenEditarNotaFiscal, setOnOpenEditarNotaFiscal] = useState(false);
  const [idProcesso, setIdProcesso] = useState(null);
  const [dataEmissaoEdit, setDataEmissaoEdit] = useState(null);

  const periodoInicial = useNotaFiscalDevedorSelector(states => states.formFields.periodoInicial.copy());
  const periodoFinal = useNotaFiscalDevedorSelector(states => states.formFields.periodoFinal.copy());
  const valorInicial = useNotaFiscalDevedorSelector(states => states.formFields.valorInicial.copy());
  const valorFinal = useNotaFiscalDevedorSelector(states => states.formFields.valorFinal.copy());
  const cpfCnpj = useNotaFiscalDevedorSelector(states => states.formFields.cpfCnpj.copy());
  const numeroProcesso = useNotaFiscalDevedorSelector(states => states.formFields.numeroProcesso.copy());
  const razaoSocial = useNotaFiscalDevedorSelector(states => states.formFields.razaoSocial.copy());

  const loading = useNotaFiscalDevedorSelector(states => states.common.loadingPage);
  const page = useNotaFiscalDevedorSelector(states => states.page);
  const rowsPerPage = useNotaFiscalDevedorSelector(states => states.rowsPerPage);
  const totalElements = useNotaFiscalDevedorSelector(states => states.totalElements);
  const tableView = useNotaFiscalDevedorSelector(states => states.tableView);
  const listIds = useNotaFiscalDevedorSelector(states => states.listIds);
  const selectAll = useNotaFiscalDevedorSelector(states => states.selectAll);
  const dadosResumo = useNotaFiscalDevedorSelector(states => states.dadosResumo);
  const idsProcessosExcluidos = useNotaFiscalDevedorSelector(states => states.idsProcessosExcluidos);

  const disablePesquisar = !periodoInicial.value
  && !periodoFinal.value
  && !valorInicial.value
  && !valorFinal.value
  && !cpfCnpj.value
  && !numeroProcesso.value
  && !razaoSocial.value;

  const changeSelectAll = useCallback((e) => {
    const { checked } = e.target;
    dispatch(setSimpleNotasFiscaisDevedorAction('selectAll', checked));
    dispatch(setSimpleNotasFiscaisDevedorAction('listIds', Object.keys(listIds).reduce((acc, key) => ({ ...acc, [key]: checked }), {})));
  }, [listIds, dispatch]);

  const changePageHandler = useCallback((event, newPage) => {
    dispatch(setSimpleNotasFiscaisDevedorAction('page', Number(newPage)));
    dispatch(setSimpleNotasFiscaisDevedorAction('tableView', tableView));
    dispatch(buscarDadosTabelaAction(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const changeRowsPerPageHandler = useCallback((e) => {
    const size = e.target.value;
    const newPage = getNewPage(rowsPerPage, page, size);

    dispatch(setSimpleNotasFiscaisDevedorAction('page', Number(newPage)));
    dispatch(setSimpleNotasFiscaisDevedorAction('rowsPerPage', Number(size)));
    dispatch(setSimpleNotasFiscaisDevedorAction('tableView', tableView));
    dispatch(buscarDadosTabelaAction(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, rowsPerPage, page]);

  const changeSelectId = useCallback((e) => {
    const { name, checked } = e.target;
    dispatch(setSimpleValuesListIdsAction(name, checked));
  }, [dispatch]);

  const onChangeHandler = useCallback((event) => {
    const { name, value } = event.target;
    dispatch(onChangeFormFieldsAction(name, value));
  }, [dispatch]);

  const changeDocumentoStringKey = useCallback((e) => {
    const { value } = e.target;
    onChangeHandler(e);
    setIsCnpj(value.length > 11);
  }, [onChangeHandler]);

  const onClickPesquisar = useCallback(() => {
    dispatch(setSimpleNotasFiscaisDevedorAction('idsProcessosExcluidos', []));

    dispatch(buscarDadosTabelaAction(true));
  }, [dispatch]);

  const onConfirmEditarNotaFiscal = useCallback(() => {
    dispatch(setSimpleNotasFiscaisDevedorAction('dadosResumo', dadosResumo.map(nota => (nota.idProcesso === idProcesso ? { ...nota, dataEmissao: dataEmissaoEdit } : nota))));

    setOnOpenEditarNotaFiscal(false);
  }, [idProcesso, dataEmissaoEdit, dispatch, dadosResumo]);

  const goToEditarNotaFiscal = useCallback((id, data) => {
    setOnOpenEditarNotaFiscal(true);
    setIdProcesso(id);
    setDataEmissaoEdit(data);
  }, [setOnOpenEditarNotaFiscal, setIdProcesso]);

  const goToExcluirNotaFiscal = useCallback((id) => {
    dispatch(setSimpleNotasFiscaisDevedorAction('idsProcessosExcluidos', [...idsProcessosExcluidos, id]));
    dispatch(buscarDadosTabelaAction(true));
  }, [dispatch, idsProcessosExcluidos]);

  const onClickGerarNotasFiscais = useCallback(() => {
    const conteudoSelecionado = dadosResumo.filter(item => listIds[item.idProcesso] === true);
    dispatch(gerarNotaFiscalDevedorAction(conteudoSelecionado));
  }, [dispatch, listIds, dadosResumo]);

  const onClickExportar = useCallback(() => {
    dispatch(exportarNotaFiscalDevedorAction());
  }, [dispatch]);

  useEffect(() => {
    setConteudoTabela(notasFiscaisDevedorFactory.makeConteudoTabela(
      tableView,
      changeSelectId,
      listIds,
      goToEditarNotaFiscal,
      goToExcluirNotaFiscal,
      dadosResumo,
    ));
    dispatchCCCliente(pesquisarDadosGeracaoNotaFiscalAction(true));
  }, [dispatchCCCliente, dadosResumo, tableView, changeSelectId, listIds, goToEditarNotaFiscal, goToExcluirNotaFiscal]);

  useEffect(() => {
    dispatch(buscarDadosTabelaAction(true));
    dispatch(setSimpleNotasFiscaisDevedorAction('tableView', tableView));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <>
      <DialogNew
        open={onOpenEditarNotaFiscal}
        text="Editar Nota Fiscal do Devedor"
        className={styles.dialogEditarNotaFiscal}
      >
        <DialogEditarNotaFiscalDevedor
          idProcesso={idProcesso}
          setDataEmissao={setDataEmissaoEdit}
          dataEmissao={dataEmissaoEdit}
          onConfirm={onConfirmEditarNotaFiscal}
          onCancel={() => setOnOpenEditarNotaFiscal(false)}
        />
      </DialogNew>
      <ContainerPrincipal>
        <LoadingUI show={loading} />
        <Grid24 container isFormContainer spacing="1" style={{ marginBottom: '16px' }}>
          <Grid24 item xs={24} sm={7}>
            <Grid24 container spacing="1">
              <Grid24 item xs={24} sm={24}>
                <PeriodField
                  label="Período de Quitação(Baixa):"
                  firstField={periodoInicial}
                  lastField={periodoFinal}
                  onChange={onChangeHandler}
                />
              </Grid24>
              <Grid24 item xs={24} sm={24} style={{ marginTop: '10px' }}>
                <Grid24
                  xs={24}
                  sm={24}
                >
                  <span style={{
                    fontSize: '12px',
                    alignSelf: 'flex-end',
                    marginRight: '10px',
                    color: 'gray',
                  }}
                  >
                    Valor Honorário Amigável:
                  </span>
                </Grid24>
                <div style={{ justifyContent: 'space-between', display: 'flex' }}>
                  <Grid24 xs={24} sm={11}>
                    <MoneyField
                      fullWidth
                      maxlength={16}
                      label="De:"
                      name={valorInicial.name}
                      value={valorInicial.value}
                      onChange={onChangeHandler}
                    />
                  </Grid24>
                  <Grid24 xs={24} sm={11}>
                    <MoneyField
                      fullWidth
                      maxlength={16}
                      label="Até:"
                      name={valorFinal.name}
                      value={valorFinal.value}
                      onChange={onChangeHandler}
                    />
                  </Grid24>
                </div>
              </Grid24>
              <Grid24 item xs={24} sm={24} style={{ marginTop: '10px' }}>
                <div style={{ justifyContent: 'space-between', display: 'flex', width: '100%' }}>
                  <Grid24 xs={24} sm={12}>
                    {isCnpj ? (
                      <AlphanumericMaskField
                        fullWidth
                        label="CPF/CNPJ"
                        name={cpfCnpj.name}
                        value={cpfCnpj.value}
                        onChange={changeDocumentoStringKey}
                      />
                    ) : (
                      <MaskField
                        fullWidth
                        label="CPF/CNPJ"
                        name={cpfCnpj.name}
                        value={cpfCnpj.value}
                        onChange={changeDocumentoStringKey}
                        format={`${CPF_MASK}#`}
                      />
                    )}
                  </Grid24>
                  <Grid24 xs={24} sm={10}>
                    <InputField
                      label="Número Processo"
                      name={numeroProcesso.name}
                      value={numeroProcesso.value}
                      maxLength={168}
                      onChange={onChangeHandler}
                    />
                  </Grid24>
                </div>
              </Grid24>
              <Grid24 item xs={24} sm={24} style={{ marginTop: '10px' }}>
                <InputField
                  fullWidth
                  label="Razão Social"
                  name={razaoSocial.name}
                  value={razaoSocial.value}
                  maxLength={60}
                  onChange={onChangeHandler}
                />
              </Grid24>
            </Grid24>
          </Grid24>
          <Grid24 item xs={24} sm={4}>
            <ButtonPesquisar disabled={disablePesquisar} type="button" onClick={() => { onClickPesquisar(); }}>
              <SearchIcon />
            </ButtonPesquisar>
          </Grid24>
          <Grid24 item xs={24} sm={13} style={{ marginBottom: '16px', flexFlow: 'column' }}>
            <Grid24 item xs={24} sm={24}>
              <WrapperSubTitleForm title="Resumo das Prestações Selecionadas" className={styles.headerResumo} />
              <ContainerResumo>
                <div>
                  <CardFooter color="#9e9e9e">
                    <p>Quantidade</p>
                    <p>{Object.values(listIds).filter(value => value === true).length}</p>
                  </CardFooter>
                  <CardFooter color="#BF00FF">
                    <p>Total</p>
                    <p>
                      {
                        getMoneyMask(
                          dadosResumo.filter(item => listIds[item.idProcesso] === true)
                            .reduce((acc, value) => acc + value.honorariosAmigaveis, 0),
                        )
                      }
                    </p>
                  </CardFooter>
                </div>
              </ContainerResumo>
            </Grid24>
            <Grid24 item xs={24} sm={24} style={{ alignItems: 'end', placeContent: 'end' }}>
              <ButtonUI
                style={{ width: 'fit-content', marginLeft: '10px' }}
                color="white"
                disabled={conteudoTabela.length === 0}
                onClick={() => { onClickExportar(); }}
              >
                Excel
              </ButtonUI>
              <ButtonUI
                style={{ width: 'fit-content', marginLeft: '10px' }}
                color="white"
                disabled={Object.values(listIds).filter(value => value === true).length === 0}
                onClick={() => { onClickGerarNotasFiscais(); }}
              >
                Gerar Notas Fiscais
              </ButtonUI>
            </Grid24>
          </Grid24>
          <Grid24 item xs={24} sm={24}>
            <TabelaNotasFiscaisDevedor
              columns={notasFiscaisDevedorFactory.makeCabecalhoTabela(
                changeSelectAll, selectAll,
              )}
              rows={conteudoTabela}
              page={page}
              size={totalElements}
              rowsPerPageOptions={[10, 15, 20]}
              rowsPerPage={rowsPerPage}
              onChangePage={changePageHandler}
              onChangeRowsPerPage={changeRowsPerPageHandler}
            />
          </Grid24>
        </Grid24>
        <Grid24 container isFormContainer spacing="1" style={{ marginBottom: '16px' }}>
          <Accordion
            style={{ marginBottom: '11px' }}
            color="purePurple"
            title="Dados para Geração das Notas Fiscais"
          >
            <AccordionDetails>
              <DadosGeracaoNF
                permissoes={permissoes}
                isNotaParaDevedores
              />
            </AccordionDetails>
          </Accordion>
        </Grid24>
      </ContainerPrincipal>
    </>
  );
}

export const NotasFiscaisDevedor = withRouter(NotasFiscaisDevedorComponent);
